import { render, staticRenderFns } from "./MaskModal.vue?vue&type=template&id=70bc342b&scoped=true&"
import script from "./MaskModal.vue?vue&type=script&lang=js&"
export * from "./MaskModal.vue?vue&type=script&lang=js&"
import style0 from "./MaskModal.vue?vue&type=style&index=0&id=70bc342b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc342b",
  null
  
)

export default component.exports